module.exports = __webpack_public_path__ + "img/submit-hover.d829bc4d.png";